import React from 'react';

import { connect } from 'react-redux';

import {saveProfilfe} from '../../actions/auth';

var config = require('../../../settings/config.json');

//const callbackUrl = encodeURIComponent("http://dev.com/profile/settings")
const callbackUrl = encodeURIComponent("https://www.writer.monok.com/profile/settings")

const s =  {
  title:{
    color: 'black',
    fontSize: 'clamp(30px, 9vw, 47px)',
    marginBottom: '30px',
    fontWeight: 'bold',
    fontFamily: "'PT Sans Narrow', sans-serif"
  }
}



class Settings extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      publications: [],
      changedKeys:[],
      status:{},
      profile:JSON.parse(JSON.stringify(this.props.user)),
      billing: null,
      saved:true,
      selectedFeed:-1
    }

  }


  upd(key, obj, index, manualSave){

    //reset autosave

    //initiate
    this.state.profile[key] = this.state.profile[key] ? this.state.profile[key] : []
    // console.log(newState)
    if(index===null || index===undefined){
      this.state.profile[key] = obj
    }else{
      this.state.profile[key][index] = obj
      if(!obj){
        this.state.profile[key].splice(index ,1)
      }
      // this.state.profile[key][index] = this.state.profile[key].filter(o=>o)
    }


    this.setState({profile:this.state.profile,
                  saved:false,
                  changedKeys:this.state.changedKeys.concat(key).filter((key,i,arr)=>arr.indexOf(key)===i),
                  addTarget:null,
                  selectedFeed:(obj ? this.state.selectedFeed : -1)},
                  !manualSave ? this.save : ()=>{})
  }

  save(){
    // this.props.user = this.state.profile
    const allowedFields = this.state.changedKeys//['anchors', 'billingAddress','websites'];
    const filteredUpdates = Object.keys(this.state.profile).reduce((obj, key) => {
        if (allowedFields.includes(key)) {
            obj[key] = this.state.profile[key];
        }
        return obj;
    }, {});

    this.props.saveProfile(filteredUpdates, true)
    // this.props.setFeeds(this.state.profile.feeds, 'profile')
    this.setState({saved:true, changedKeys:[]}) //profile: this.state.profile,
  }

  render () {

    if(!this.props.user){
      return null
    }

    var self = this
    let saved = this.state.saved
    // const user = this.props.user;
    // let feeds = profileFeeds
    let feeds = this.state.profile.feeds


    let role = this.props.user.curator ? 'curator' : (this.props.user.writer ? 'writer' : (this.props.user.admin ? 'admin' : null))

    return (
      <div  style={{width:'100%',maxWidth:800, margin:'auto', paddingTop:100, paddingBottom:200, textAlign:'center'}}>
        {saved ? null : <div className={"whitebutton highlight save"} style={{cursor:'pointer'}} onClick={()=>this.save()}>
            Save Changes
          </div>}

        {user.writer ? <div>
          <p style={s.title}>Your Paypal e-mail</p>
          <input
            type="email"
            id="paypal"
            name="paypal"
            placeholder="Paypal e-mail"
            value={this.state.profile.paypal || (this.state.profile.email || '')}
            onChange={(e) => this.upd('paypal', e.target.value, null, true)}
            style={{width:'100%', padding: 10, borderRadius: 15, fontSize:'large', border: 'solid 1px #ccc4c4' }}
          />
        </div> : null}

      </div>
    );
  }
}


const mapStateToProps = (state)=>{
  return {
    user:state.auth.user,
    feeds:state.feeds,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveProfile:(newProfile, partial)=>dispatch(saveProfile(newProfile, partial)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)
